<template>
  <v-snackbar v-model="model" :color="snackbar.type" :timeout="snackbar.timeout" app v-show="this.model">
    <v-icon :dark="snackbar.type !== 'warning'" class="mr-2">{{ icon }}</v-icon>
    <span :class="snackbar.type === 'warning' ? 'text-black' : 'text-white'">
      <template v-if="snackbar.content">
        <component
          v-for="(part, index) in snackbar.content"
          :key="index"
          :is="part.href ? 'a' : 'span'"
          :class="{ 'snackbar-link': part.href }"
          :href="part.href"
        >{{ part.text }}</component>
      </template>
      <template v-else>{{ snackbar.msg }}</template>
    </span>
  </v-snackbar>
</template>

<script>
// Utilities
import { mapState } from "vuex";

const ICON_MAP = {
  error: "mdi-alert-octagon",
  info: "mdi-information",
  success: "mdi-check-circle",
  warning: "mdi-alert-circle",
};

export default {
  name: 'SnackbarComponent',
  data: () => ({
    model: false,
  }),

  computed: {
    ...mapState(["snackbar"]),

    icon() {
      return ICON_MAP[this.snackbar.type] || "mdi-playlist-check";
    },
  },

  watch: {
    snackbar() {
      this.model = true;
    },
  },
};
</script>

<style scoped>
.snackbar-link {
  color: inherit;
  font-weight: 500;
}
</style>
